<template>
	
	<div class="content-area__inner content-area__my-profile">
		
		<ContentAreaTitle :title="$auth.user().name"></ContentAreaTitle>
		
	</div>
	
</template>

<script>
	
	import ContentAreaTitle from "@/components/ContentAreaTitle";
	
	export default {
		
		name: "MyProfile",
		
		components: { ContentAreaTitle },
		
		mounted() {
			
			/*var name = "Simon";
			var email = "simon@burford.me";
			var password = "test23";
			
			this.$auth.register({
				params: {name: name, email: email, password: password},
				success: function(e) {
					console.log(e);
				},
				error: function(e) {
					console.log(e);
				},
			});*/
			
		},
		
		methods: {
			
			/*register: function() {
				
				var name = "Simon";
				var email = "simon@burford.me";
				var password = "test23";
				
				this.$auth.register({
					params: {name: name, email: email, password: password},
					success: function(e) {
						console.log(e);
					},
					error: function(e) {
						console.log(e);
					},
				});  
				
			},*/
			
		}
		
	}
	
</script>

<style scoped>
	
	
	
</style>


// WEBPACK FOOTER //
// src/components/MyProfile.vue